{
  "reportingConfiguration": {
    "title": "Configuración de informes",
    "information": "Se enviará un informe a intervalos regulares a los contactos configurados a continuación.",
    "frequency": "Periodicidad del informe (en días)",
    "time": "Hora del informe"
  },
  "recipients": {
    "title": "Destinatarios",
    "users": {
      "empty": "Ningún destinatario",
      "select": {
        "label": "Añadir destinatarios"
      },
      "add": {
        "label": "Añadir destinatarios",
        "notification": {
          "success": "Se han añadido los siguientes destinatarios"
        }
      },
      "remove": {
        "label": "Quitar los destinatarios seleccionados",
        "confirm": {
          "title": "Quitar los destinatarios",
          "message": "Se quitarán los siguientes destinatarios :"
        },
        "notification": {
          "success": "Se han quitado los siguientes destinatarios"
        }
      }
    }
  },
  "validation": {
    "frequency": {
      "required": "La periodicidad del informe es obligatorio"
    },
    "time": {
      "required": "La hora del informe es obligatoria"
    }
  }
}
